import { http } from "./http";

async function getWarehouseDetails(page, rowsPerPage) {
  const response = await http.get(
    `/warehouse-details-obsolete/?page=${page}&pageSize=${rowsPerPage}`,
  );
  return response;
}

async function putWarehouseDetails(id, newItem) {
  const response = await http.put(`/warehouse-details-obsolete/${id}`, newItem);
  return response;
}

async function updateShippingLable(id, label, value) {
  const response = await http.patch(`/shippings/${id}/lables/${label}`, {
    value,
  });
  return response;
}

export { getWarehouseDetails, putWarehouseDetails, updateShippingLable };
